import React from 'react';
import { Button } from 'primereact/button';

function UserDetailsErrorScreen({ onRetry }) {
  return (
    <div style={styles.container}>
      <i className="pi pi-exclamation-triangle" style={styles.icon} />
      <h2 style={styles.heading}>Something went wrong</h2>
      <p style={styles.message}>We were unable to load your account details. Please try again.</p>
      <Button label="Retry" className="p-button-primary" onClick={onRetry} />
    </div>
  );
}

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    color: 'var(--black-500)',
    textAlign: 'center',
    padding: '0 20px',
  },
  icon: {
    fontSize: '3rem',
    color: 'var(--danger-500, #e24c4c)',
  },
  heading: {
    fontSize: '1.8rem',
    margin: 0,
  },
  message: {
    fontSize: '1rem',
    margin: 0,
    maxWidth: '400px',
  },
};

export default UserDetailsErrorScreen;
